import { render } from "./TheCartEmpty.vue?vue&type=template&id=d5319ffa"
import script from "./TheCartEmpty.vue?vue&type=script&lang=js"
export * from "./TheCartEmpty.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__